module.exports = __webpack_public_path__ + "assets/c07002385df67a64484ce6de8f70ea3c.svg";